export default __webpack_public_path__ + "static/media/logo-white.424a5135.svg";